<div class="payment-redirect-container">
  <div class="payment-redirect-card">
    <h2>Przekierowanie płatności</h2>

    <div class="redirect-info">
      <p>
        Wygląda na to, że Twoja przeglądarka zablokowała otwieranie
        wyskakujących okienek płatności.
      </p>
      <p>Możesz kontynuować na jeden z poniższych sposobów:</p>
    </div>

    <div class="button-container">
      <button
        class="btn btn-primary"
        (click)="redirectToPayment()">
        Spróbuj ponownie w nowym oknie
      </button>
    </div>

    <div class="note">
      <p>
        <strong>Uwaga:</strong> Jeśli wolisz, możesz również odblokować
        wyskakujące okienka dla tej witryny w ustawieniach przeglądarki, a
        następnie wrócić do poprzedniej strony.
      </p>
    </div>
  </div>
</div>
